export default __webpack_public_path__ + "static/media/starWars.55fc62bd.PNG";